import DostClient from "./DostClient";

export default function DostPage() {
  return <DostClient />;
}
